import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
export const loginRequestSchema = z.object({
    username: z.string().trim().min(1).max(64),
    password: z.string().min(1).max(256),
});
export const userSchema = z.object({
    id: idSchema,
    username: z.string(),
    createdAt: isoDateTimeSchema,
});
export const sessionInfoSchema = z.object({
    user: userSchema,
    expiresAt: isoDateTimeSchema,
});
/** Minimum length enforced on the admin password at startup. */
export const MIN_PASSWORD_LENGTH = 10;
export const changePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(MIN_PASSWORD_LENGTH).max(256),
});
//# sourceMappingURL=auth.js.map